// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1__ec4ad676e2c607913fd1","cls2":"UserTooltip-cls2__f4780e17938882585d85 UserTooltip-cls1__ec4ad676e2c607913fd1"};